module.exports = __webpack_public_path__ + "static/media/ge.7cae6cbe.svg";